module.exports = __webpack_public_path__ + "img/image28.c8e2cb26.jpg";